import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { setTeamSettingSidebarExpanded } from "../../../actions/teamSettingSidebar";
import { number } from "../../../config";
import "../../Tasks/tasks.scss";
import { TEAM_SETTING_DEFAULT_EXPANDED, teamSettingSidebarNavOptions } from "./teamSettingSidebar.constants";

/**
 * TeamSettingSidebarSidepanel component handles the quick action button logic for the team setting sidebar.
 * @author Bhavana
 */
const TeamSettingSidebarSidepanel = () => {
  const [focusedElementId, setFocusedElementId] = useState(teamSettingSidebarNavOptions[0]?.id);
  const dispatch = useDispatch();
  const expanded =
    useSelector((state) => state.teamSettingSidebar?.expanded) ?? TEAM_SETTING_DEFAULT_EXPANDED;

  /**
   * Handles the quick action button click for the team setting sidebar.
   * @param {Object} section - The section object.
   * @returns {void}
   */
  const handleQuickActionButton = (section) => {
    const sectionId = section.id;
    setFocusedElementId(sectionId);
    if (!expanded.includes(sectionId)) {
      dispatch(setTeamSettingSidebarExpanded([...expanded, sectionId]));
    }
    const scrollToSection = () => {
      document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth", block: "start" });
    };
    setTimeout(scrollToSection, number.SIX_HUNDRED);
  };

  return (
    <div className="sidepanel-quick-actions text-center d-flex flex-column align-items-center justify-content-center my-4">
      <Tooltip anchorElement="target" position="left" parentTitle="true">
        {teamSettingSidebarNavOptions.map((section) => (
          <button
            id={section.id}
            type="button"
            title={section.title}
            key={section.id}
            className={`cursor-pointer tooltip-text position-relative d-inline-block action-icons sidebar-action-buttons-color border-0 bg-transparent mb-1 d-flex align-items-center justify-content-center ${
              focusedElementId === section.id ? "active-quick-actions" : ""
            }`}
            onClick={() => handleQuickActionButton(section)}>
            {section.icon}
          </button>
        ))}
      </Tooltip>
    </div>
  );
};

export default TeamSettingSidebarSidepanel;
